import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { Controller } from "react-hook-form";

import { DiscoveryStep } from "~/components/ui/discovery-step";
import { FormField } from "~/components/ui/form-field";
import { Textarea } from "~/components/ui/textarea";
import { useDiscoveryForm } from "~/lib/hooks/use-discovery-form";
import {
  PersonalContext,
  personalContextField,
  personalContextStep,
} from "~/lib/schemas/coach-discovery";
import type { PersonalContextForm } from "~/lib/schemas/coach-discovery";
import { createNoIndexMeta } from "~/lib/shared/meta";

export const Route = createFileRoute("/_public/discovery/steps/10/")({
  head: () =>
    createNoIndexMeta(
      "Step 10: Personal Context – Dream Coach Match",
      "Share your personal context to help us match you with the right coach",
    ),
  component: Step10Component,
});

function Step10Component() {
  const { form, handleNextStep, handlePreviousStep } = useDiscoveryForm({
    step: 10,
    schema: PersonalContext,
  });

  const { handleSubmit, control, formState } = form;
  const { errors, isValid, isSubmitting } = formState;

  const onSubmit = (_data: PersonalContextForm) => {
    handleNextStep();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <DiscoveryStep.Title title={personalContextStep.title} />
      <DiscoveryStep.Card>
        <FormField error={errors.personalContext?.message}>
          <Controller
            name="personalContext"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <Textarea
                value={field.value}
                onValueChange={field.onChange}
                maxLength={personalContextField.maxLength}
                placeholder={personalContextField.placeholder}
              />
            )}
          />
        </FormField>
      </DiscoveryStep.Card>
      <DiscoveryStep.Control
        prev={handlePreviousStep}
        type="submit"
        disabled={!isValid}
        loading={isSubmitting}
      />
    </form>
  );
}
